import styled from 'styled-components';
import colors from '../../../../includes/colors';

export const ContactIcon = styled.span`
  color: ${colors.blue};
  font-size: ${props => props.size || '1.5rem'} !important;
  margin-right: ${props => props.marginRight || '0'};
`;
